<script>
import Layout from "../../layouts/main";
import PageHeader from "../../components/page-header";
import DatePicker from "vue2-datepicker";
import moment from "moment";
import Swal from "sweetalert2";
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
dayjs.extend(customParseFormat);
/**
 * Starter component
 */
export default {
    components: { Layout, PageHeader, DatePicker },
    data() {
        return {
            isLoading:false,
            title: "Pagos Laborantes",
            items: [
                {
                text: "Laborantes",
                href: "/"
                },
                {
                text: "Pago",
                active: true
                }
            ],
            usuarios:[],
            totalRows: 1,
            currentPage: 1,
            perPage: 10,
            pageOptions: [10, 25, 50, 100],
            filtro: '',
            desde:'',
            hasta:'',
            pagos_laborantes:[],
            laborantes:[],
            eventos:[],
            pago_editar:[],
            valores_pago:[],
            tipos:[],
            subtipos:[],
            bulkStatus:false
        };
    },
    computed:{
        esSupervisor() {
            return this.user && this.user.rol === 'Supervisor';
        },
        filteredData() {
            this.bulkStatus=false

            // Filtramos los datos en base al campo 'filtro'
            let datos = this.pagos_laborantes.filter((item) => {
                if ((item.rol || '') == 'Coordinador') {
                    return false;
                }
                if(item.status==false){
                    this.bulkStatus=true
                }
                // Aquí puedes personalizar los campos a buscar
                return (
                    item.nombre_laborante.toLowerCase().includes(this.filtro.toLowerCase()) ||
                    item.sede.toLowerCase().includes(this.filtro.toLowerCase()) ||
                    item.codigo.toLowerCase().includes(this.filtro.toLowerCase()) ||
                    item.coordinador.toLowerCase().includes(this.filtro.toLowerCase())
                );
            });

            // Ordenar por valor_liquido de mayor a menor
            return datos.sort((a, b) => {
                const montoA = parseInt(a.valor_liquido) || 0;
                const montoB = parseInt(b.valor_liquido) || 0;
                return montoB - montoA; // Mayor a menor
            });
        },
        // paginatedData() {
        //     const start = (this.currentPage - 1) * this.perPage;
        //     const end = start + this.perPage;
        //     return this.filteredData.slice(start, end)
        // },
        totalRows() {
            return this.filteredData.length;
        },
        registrosFaltantesConValores() {
            return this.filteredData.filter((item) => {
                return !this.esPagoSeleccionado(item)
                    && this.obtenerNumero(item.valor_bruto) > 0;
            });
        },
        registrosSeleccionadosConValores() {
            return this.filteredData.filter((item) => {
                return this.esPagoSeleccionado(item)
                    && this.obtenerNumero(item.valor_bruto) > 0;
            });
        },
        registrosFaltantesFiltrados() {
            return this.filteredData.filter((item) => !this.esPagoSeleccionado(item));
        },
        registrosSeleccionadosFiltrados() {
            return this.filteredData.filter((item) => this.esPagoSeleccionado(item));
        },
        resumenFiltrado() {
            return this.filteredData.reduce((totales, item) => {
                totales.valor_bruto += this.obtenerNumero(item.valor_bruto);
                totales.valor_liquido += this.obtenerNumero(item.valor_liquido);
                return totales;
            }, {
                valor_bruto: 0,
                valor_liquido: 0,
            });
        },
    },
    methods:{
        obtenerRangoFechas() {
            const hoy = new Date();
            const diaHoy = hoy.getDate();
            const mesHoy = hoy.getMonth();
            const anioHoy = hoy.getFullYear();

            let fechaInicio, fechaFin;

            if (diaHoy <= 25) {
                // Si hoy es menor o igual a 25, el rango es del 26 del mes anterior al 25 de este mes
                const mesAnterior = mesHoy === 0 ? 11 : mesHoy - 1;
                const anioInicio = mesHoy === 0 ? anioHoy - 1 : anioHoy;
                fechaInicio = new Date(anioInicio, mesAnterior, 26);
                fechaFin = new Date(anioHoy, mesHoy, 25);
            } else {
                // Si hoy es mayor a 25, el rango es del 26 de este mes al 25 del mes siguiente
                const mesSiguiente = mesHoy === 11 ? 0 : mesHoy + 1;
                const anioFin = mesHoy === 11 ? anioHoy + 1 : anioHoy;
                fechaInicio = new Date(anioHoy, mesHoy, 26);
                fechaFin = new Date(anioFin, mesSiguiente, 25);
            }
            this.desde = moment(fechaInicio).format('YYYY-MM-DD');
            this.hasta = moment(fechaFin).format('YYYY-MM-DD');
            //return { fechaInicio, fechaFin };
        },
        fecha_mes_actual(val){
            const fechaActual = new Date(); // Obtiene la fecha actual
            const primerDiaMes = new Date(fechaActual.getFullYear(), fechaActual.getMonth(),val); // Configura el día como 1
            return moment(primerDiaMes).format('YYYY-MM-DD');
        },
        mostrarmes(){
            this.isLoading=true;
            axios.get('/api/pagos/'+this.desde+'/'+this.hasta).then(response => {
                this.pagos_laborantes= response.data.pagos_laborantes;
                this.isLoading=false;
            });
        },
        obtenerLabotante(element){
            let laborante = this.laborantes.filter((us) => us.id==element);
            if (laborante.length>0) {
                return laborante[0].name;
            }
        },
        obtenerSede(element){
            let laborante = this.laborantes.filter((us) => us.id==element);
            if (laborante.length>0) {
                return laborante[0].sede;
            }
        },
        obtenerEvento(element){
            let evento = this.eventos.filter((us) => us.id==element);
            if (evento.length>0) {
                return evento[0];
            }else{
                let evento={
                    codigo:'',
                    coordinador_evento:'',
                }
                return evento
            }
        },
        msg(title) {
            Swal.fire({
                icon: 'success',
                title: title,
                //text: `Por favor, completa el campo "${campo}".`,
                showConfirmButton: false,
                timer: 1000
            });
        },
        seleccionar(item){
            if (this.esSupervisor) {
                return;
            }
            let formData = new FormData();
            formData.append('pago_id', item.id);
            formData.append('status', item.status);
            axios.post('/api/seleccionar_pago',formData).then(response => {
                this.msg('Guardado')
            });
        },
        esPagoSeleccionado(item) {
            return item.status === true || item.status === 1 || item.status === '1';
        },
        async guardarSeleccionados(registros, status, mensajeVacio) {
            if (this.esSupervisor) {
                return;
            }
            try {
                this.isLoading = true;
                // armamos un FormData (puedes usar JSON directamente si tu API lo permite)
                const formData = new FormData()
                let ids=[];
                registros.forEach(reg => ids.push(reg.id) )
                if (!ids.length) {
                    this.msg(mensajeVacio)
                    this.isLoading = false;
                    return;
                }
                formData.append('pago_ids', ids)
                formData.append('status', status)
                console.log(formData)
                const resp = await axios.post('/api/seleccionar_pagos_lote', formData)
                this.msg(`Se actualizaron ${ids.length} pagos`)

                // opcional: refrescar la tabla o actualizar localmente los status
                await this.mostrarmes()
                this.isLoading = false;

                } catch (err) {
                    console.error(err)
                    this.msg('Error al guardar los pagos', 'error')
            }
            this.isLoading = false;
        },
        seleccionarTodosFiltrados() {
            return this.guardarSeleccionados(
                this.registrosFaltantesFiltrados,
                1,
                'No hay registros filtrados pendientes por seleccionar'
            );
        },
        deseleccionarTodosFiltrados() {
            return this.guardarSeleccionados(
                this.registrosSeleccionadosFiltrados,
                0,
                'No hay registros filtrados seleccionados por deseleccionar'
            );
        },
        seleccionarFaltantesConValores() {
            return this.guardarSeleccionados(
                this.registrosFaltantesConValores,
                1,
                'No hay faltantes con valor bruto mayor a 0'
            );
        },
        deseleccionarConValores() {
            return this.guardarSeleccionados(
                this.registrosSeleccionadosConValores,
                0,
                'No hay registros seleccionados con valor bruto mayor a 0'
            );
        },
        formatFecha(fechahora){
            var orden = moment(fechahora).format('DD-MM-YYYY');
            return orden
        },
        modal_editar(item){
            this.pago_editar=item;
            this.$refs['modal-editar'].show()
        },
        obtenerNumero(valor){
            if (valor === null || valor === undefined) {
                return 0;
            }
            if (typeof valor === 'number') {
                return valor;
            }
            return parseInt(valor.toString().replace(/\D/g, ''), 10) || 0;
        },
        obtenerRetencionLaborante(laborante){
            const porcentaje = laborante && laborante.retencion
                ? parseFloat(laborante.retencion.toString().replace(',', '.'))
                : 0;
            return 1 - (porcentaje / 100);
        },
        obtenerTipoSubtipoPago(){
            const tipoId = this.pago_editar.tipo_id || this.pago_editar.tipo;
            const subtipoId = this.pago_editar.subtipo_id || this.pago_editar.subtipo;
            const tipo = this.tipos.find(t => String(t.id) === String(tipoId));
            const subtipo = this.subtipos.find(s => String(s.id) === String(subtipoId));
            return { tipo, subtipo };
        },
        editar(){
            let formData = new FormData();
            formData.append('pago_id', this.pago_editar.id);
            formData.append('fecha', this.pago_editar.fecha);
            formData.append('hora_inicio', this.pago_editar.hora_inicio);
            formData.append('hora_fin', this.pago_editar.hora_fin);
            formData.append('cantidad_encuestas', this.pago_editar.cantidad_encuestas);
            formData.append('total_horas', this.pago_editar.total_horas || 0);
            formData.append('valor_bruto', this.pago_editar.valor_bruto);
            formData.append('valor_liquido', this.pago_editar.valor_liquido);
            axios.post('/api/editar_pagar',formData).then(response => {
                if (response.data.estado) {
                    this.msg('Pago Editado')
                    axios.get('/api/pagos/'+this.desde+'/'+this.hasta).then(response => {
                        this.pagos_laborantes= response.data.pagos_laborantes;
                    });
                }
            });
        },
        eliminar(item){
            let formData = new FormData();
            formData.append('pago_id', item.id);
            Swal.fire({
                title: "¿Está seguro que desea eliminar este pago?",
                text: "¡No podrás revertir esto! ",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#C87838",
                cancelButtonColor: "#d33",
                confirmButtonText: "Si, estoy seguro"
            }).then((result) => {
                if (result.isConfirmed) {
                    axios.post('/api/eliminar_pagar',formData).then(response => {
                        if (response.data.estado) {
                            Swal.fire({
                                title: "Eliminado",
                                text: "La información ha sido borrada",
                                icon: "success",
                                showConfirmButton: false,
                                timer: 1000
                            });
                            axios.get('/api/pagos/'+this.desde+'/'+this.hasta).then(response => {
                                this.pagos_laborantes= response.data.pagos_laborantes;
                            });
                        }
                    });
                }
            });
        },
        format_Valor(){
            this.pago_editar.valor_liquido=this.format_Valor_variable(this.pago_editar.valor_liquido)
            this.pago_editar.valor_bruto=this.format_Valor_variable(this.pago_editar.valor_bruto)
        },
        format_Valor_variable(val){
            return val? parseInt(val.toString().replace(/[^0-9]/g, ''), 10)? parseInt(val.toString().replace(/[^0-9]/g, ''), 10).toLocaleString("es-CL", { style: "currency", currency: "CLP" }): '$0': '$0';
        },
        valor_pago_actualizar(){
            let tipo_laborante = this.pago_editar.tipo_laborante;
            let laborante = this.laborantes.filter((us) => us.id==this.pago_editar.laborante_id)[0];
            if (!laborante) {
                return;
            }

            const inicio = dayjs(`${this.pago_editar.fecha} ${this.pago_editar.hora_inicio}`, 'YYYY-MM-DD HH:mm');
            const fin = dayjs(`${this.pago_editar.fecha} ${this.pago_editar.hora_fin}`, 'YYYY-MM-DD HH:mm');
            let diffHoras = Math.abs(fin.diff(inicio, 'hour', true));
            if (!Number.isFinite(diffHoras)) {
                diffHoras = 0;
            }
            this.pago_editar.total_horas = parseFloat(diffHoras.toFixed(2));

            if (tipo_laborante=='Apoyo') {
                const { tipo, subtipo } = this.obtenerTipoSubtipoPago();
                if (tipo && subtipo) {
                    let valor = null;
                    let valores = this.valores_pago.filter(v => v.tipo_id == tipo.id && v.subtipo_id == subtipo.id && v.tipo_laborante.includes(tipo_laborante));
                    if (tipo.nombre.toLowerCase() === 'charla' && subtipo.nombre.toLowerCase().includes('presencial')) {
                        valor = valores.find(v => v.tipo_laborante == 'Apoyo');
                    } else {
                        if (valores.length == 1) {
                            valor = valores[0];
                        } else if (valores.length > 1) {
                            valor = valores.reduce((closest, item) => {
                                return Math.abs(diffHoras - item.duracion_maxima) < Math.abs(diffHoras - closest.duracion_maxima) ? item : closest;
                            }, valores[0]);
                        }
                    }
                    const retencion = this.obtenerRetencionLaborante(laborante);
                    let valorLiquido = 0;
                    let valorBruto = 0;
                    if (valor) {
                        const tiempoExtra = diffHoras - valor.duracion_maxima;
                        const valorBase = this.obtenerNumero(valor.valor_liquido);
                        const valorExtra = this.obtenerNumero(valor.hora_extra) * tiempoExtra;
                        valorLiquido = tiempoExtra <= 0 ? valorBase : valorBase + valorExtra;
                        valorBruto = Math.round(valorLiquido / retencion);
                        this.pago_editar.valor_liquido=Math.round(valorLiquido);
                        this.pago_editar.valor_bruto=valorBruto;
                    }
                }
            }else if(tipo_laborante=='Relator'){
                const { tipo, subtipo } = this.obtenerTipoSubtipoPago();
                if (tipo && subtipo) {
                    let valor = null;
                    let valores = this.valores_pago.filter(v => v.tipo_id == tipo.id && v.subtipo_id == subtipo.id && v.tipo_laborante.includes(tipo_laborante));
                    if (tipo.nombre.toLowerCase() === 'charla' && subtipo.nombre.toLowerCase().includes('presencial')) {
                        valor = valores.find(v => v.tipo_laborante == 'Relator');
                    } else {
                        if (valores.length == 1) {
                            valor = valores[0];
                        } else if (valores.length > 1) {
                            valor = valores.reduce((closest, item) => {
                                return Math.abs(diffHoras - item.duracion_maxima) < Math.abs(diffHoras - closest.duracion_maxima) ? item : closest;
                            }, valores[0]);
                        }
                    }
                    const retencion = this.obtenerRetencionLaborante(laborante);
                    let valorLiquido = 0;
                    let valorBruto = 0;
                    if (valor) {
                        const tiempoExtra = diffHoras - valor.duracion_maxima;
                        const valorBase = this.obtenerNumero(valor.valor_liquido);
                        const valorExtra = this.obtenerNumero(valor.hora_extra) * tiempoExtra;
                        valorLiquido = tiempoExtra <= 0 ? valorBase : valorBase + valorExtra;
                        valorBruto = Math.round(valorLiquido / retencion);
                        this.pago_editar.valor_liquido=Math.round(valorLiquido);
                        this.pago_editar.valor_bruto=valorBruto;
                    }
                }
            }else if (tipo_laborante=='Apoyo Oficina') {
                const tipo = this.tipos.find(t => t.nombre == 'Apoyo por hora');
                const subtipo = this.subtipos.find(s => s.nombre == 'Apoyo por hora');
                if (tipo && subtipo) {
                    let valor = this.valores_pago.filter(v => v.tipo_id == tipo.id && v.subtipo_id == subtipo.id)[0];
                    const retencion = this.obtenerRetencionLaborante(laborante);
                    let valorLiquido = 0;
                    let valorBruto = 0;
                    if (valor) {
                        const valorBase = this.obtenerNumero(valor.valor_liquido);
                        valorLiquido = valorBase * diffHoras;
                        valorBruto = Math.round(valorLiquido / retencion);
                        this.pago_editar.valor_liquido=Math.round(valorLiquido);
                        this.pago_editar.valor_bruto=valorBruto;
                    }
                }
            }else if(tipo_laborante=='Salida'){
                const tipo = this.tipos.find(t => t.nombre == 'Salida por actividades');
                const subtipo = this.subtipos.find(s => s.nombre == 'Salida por actividades');
                if (tipo && subtipo) {
                    let valor = null;
                    if (diffHoras < 8) {
                        valor = this.valores_pago.find(v => v.tipo_id == tipo.id && v.subtipo_id == subtipo.id && Number(v.duracion_maxima) === 6);
                    } else {
                        valor = this.valores_pago.find(v => v.tipo_id == tipo.id && v.subtipo_id == subtipo.id && Number(v.duracion_maxima) === 8);
                    }
                    const retencion = this.obtenerRetencionLaborante(laborante);
                    let valorLiquido = 0;
                    let valorBruto = 0;
                    if (valor) {
                        const tiempoExtra = diffHoras - Number(valor.duracion_maxima || 0);
                        const valorBase = this.obtenerNumero(valor.valor_liquido);
                        const valorExtra = this.obtenerNumero(valor.hora_extra) * tiempoExtra;
                        valorLiquido = tiempoExtra <= 0 ? valorBase : valorBase + valorExtra;
                        valorBruto = Math.round(valorLiquido / retencion);
                        this.pago_editar.valor_liquido=Math.round(valorLiquido);
                        this.pago_editar.valor_bruto=valorBruto;
                    }
                }
            }else if(tipo_laborante=='Digitalizador'){
                const tipo = this.tipos.find(t => t.nombre == 'Encuesta digitada');
                const subtipo = this.subtipos.find(s => s.nombre == 'Encuesta digitada');
                if (tipo && subtipo) {
                    //let valor = null;
                    let valor = this.valores_pago.filter(v => v.tipo_id == tipo.id && v.subtipo_id == subtipo.id)[0];
                    const retencion = this.obtenerRetencionLaborante(laborante);
                    let valorLiquido = 0;
                    let valorBruto = 0;
                    if (valor) {
                        //const tiempoExtra = diffHoras - valor.duracion_maxima;
                        const valorBase = this.obtenerNumero(valor.valor_liquido);
                        //const valorExtra = parseInt(valor.hora_extra.replace(/\D/g, ''), 10) * tiempoExtra;
                        valorLiquido = valorBase * this.pago_editar.cantidad_encuestas;
                        valorBruto = Math.round(valorLiquido / retencion);
                        this.pago_editar.valor_liquido=Math.round(valorLiquido);
                        this.pago_editar.valor_bruto=valorBruto;
                    }
                }
            }
        }
    },
    created(){
        this.isLoading=true
        this.obtenerRangoFechas();
        //this.desde = this.fecha_mes_actual(1);
        //this.hasta = this.fecha_mes_actual(25);
        this.mostrarmes();
        axios.get('/api/get_laborantes').then(response => {
            this.laborantes= response.data.usuarios;
        });
        axios.get('/api/get_eventos').then(response => {
            this.eventos= response.data.eventos;
        });
        axios.get('/api/get_valores_pago').then(response => {
            this.valores_pago= response.data.valores;
        });
        axios.get('/api/get_tipos').then(res=>{
            this.tipos=res.data.tipos
            this.subtipos=res.data.subtipos
        });
    }
};
</script>
<template>
    <Layout>
        <loading-message v-if="isLoading" />
        <PageHeader :title="title" :items="items" />
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-body">
                        <div class="row mt-4">
                            <div class="col-md-5">
                                <b-form-group id="example text" label-cols-sm="2" label-cols-lg="2" label="Desde :" label-for="text" >
                                    <date-picker v-model="desde" value-type="YYYY-MM-DD" format="DD-MM-YYYY" :first-day-of-week="2" lang="es" ></date-picker>
                                </b-form-group>
                            </div>
                            <div class="col-md-5">
                                <b-form-group id="example text" label-cols-sm="2" label-cols-lg="2" label="Hasta :" label-for="text" >
                                    <date-picker v-model="hasta" value-type="YYYY-MM-DD" format="DD-MM-YYYY" :first-day-of-week="2" lang="es" ></date-picker>
                                </b-form-group>
                            </div>
                            <div class="col-md-2">
                                <b-button variant="primary" block class="mb-4" @click="mostrarmes">Ver</b-button>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
            <div class="col-md-12">
                <div class="card">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-sm-12 col-md-6">
                                <div id="tickets-table_length" class="dataTables_length">
                                    <label class="d-inline-flex align-items-center">
                                        Total de {{filteredData.length}}
                                    </label>
                                </div>
                            </div>
                            <div class="col-sm-12 col-md-6">
                                <div id="tickets-table_filter" class="dataTables_filter text-md-right">
                                    <label class="d-inline-flex align-items-center">
                                        Buscar:
                                        <b-form-input
                                        v-model="filtro"
                                        type="search"
                                        placeholder="Buscar..."
                                        class="form-control form-control-sm ml-2"
                                        ></b-form-input>
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div class="row mb-3">
                            <div class="col-md-3 col-sm-6 mb-2">
                                <div class="border rounded p-2 h-100">
                                    <div class="text-muted small">Total bruto filtrado</div>
                                    <strong>{{ format_Valor_variable(resumenFiltrado.valor_bruto) }}</strong>
                                </div>
                            </div>
                            <div class="col-md-3 col-sm-6 mb-2">
                                <div class="border rounded p-2 h-100">
                                    <div class="text-muted small">Total líquido filtrado</div>
                                    <strong>{{ format_Valor_variable(resumenFiltrado.valor_liquido) }}</strong>
                                </div>
                            </div>
                            <div class="col-md-3 col-sm-6 mb-2">
                                <div class="border rounded p-2 h-100">
                                    <div class="text-muted small">Faltantes con valores</div>
                                    <strong>{{ registrosFaltantesConValores.length }}</strong>
                                </div>
                            </div>
                        </div>
                        <div class="table-responsive mb-0 mt-3">
                            <div class="mb-3" v-if="!esSupervisor">
                                <div class="d-flex flex-wrap align-items-center mb-2" style="gap: 8px;">
                                    <b-button size="sm" variant="primary" @click="seleccionarTodosFiltrados" :disabled="registrosFaltantesFiltrados.length === 0">
                                        Seleccionar todos ({{ registrosFaltantesFiltrados.length }})
                                    </b-button>
                                    <b-button size="sm" variant="outline-primary" @click="deseleccionarTodosFiltrados" :disabled="registrosSeleccionadosFiltrados.length === 0">
                                        Deseleccionar todos ({{ registrosSeleccionadosFiltrados.length }})
                                    </b-button>
                                    <b-button size="sm" variant="warning" @click="seleccionarFaltantesConValores" :disabled="registrosFaltantesConValores.length === 0">
                                        Seleccionar faltantes con valores ({{ registrosFaltantesConValores.length }})
                                    </b-button>
                                    <b-button size="sm" variant="outline-warning" @click="deseleccionarConValores" :disabled="registrosSeleccionadosConValores.length === 0">
                                        Deseleccionar con valores ({{ registrosSeleccionadosConValores.length }})
                                    </b-button>
                                </div>
                                <small class="text-muted d-block">
                                    "Con valores" considera solo registros filtrados con Valor Bruto mayor a 0. "Todos" aplica sobre todos los registros filtrados visibles, tengan o no monto.
                                </small>
                            </div>
                            <table class="table table-hover">
                                <thead>
                                    <tr>
                                        <th style="width: 2%;"></th>
                                        <th style="width: 18%;">Nombre</th>
                                        <th style="width: 5%;">Sede</th>
                                        <th style="width: 9%;">Tipo</th>
                                        <th style="width: 9%;">Fecha</th>
                                        <th style="width: 9%;">Hora inicio</th>
                                        <th style="width: 7%;">Hora fin</th>
                                        <th style="width: 7%;">Cant. horas</th>
                                        <th style="width: 9%;">Evento</th>
                                        <th style="width: 15%;">Coordinador</th>
                                        <th style="width: 5%;">Valor Bruto</th>
                                        <th style="width: 5%;">Valor Líquido</th>
                                        <th style="width: 10%;">Acción</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(item, index) in filteredData" :key="index">
                                        <td>
                                            <b-form-checkbox
                                                :id="'checkbox-'+index"
                                                v-model="item.status"
                                                name="checkbox-1"
                                                value="1"
                                                unchecked-value="0"
                                                :disabled="esSupervisor"
                                                @change="seleccionar(item)"
                                                >
                                            </b-form-checkbox>
                                        </td>
                                        <td>{{ item.nombre_laborante }}</td>
                                        <td>{{ item.sede }}</td>
                                        <td>{{ item.tipo_laborante }}</td>
                                        <td>{{ formatFecha(item.fecha) }}</td>
                                        <td>{{ item.hora_inicio }}</td>
                                        <td>{{ item.hora_fin }}</td>
                                        <td>{{ item.total_horas==null?'':parseFloat(item.total_horas).toFixed(2) }}</td>
                                        <td>{{ item.codigo }}</td>
                                        <td>{{ item.coordinador }}</td>
                                        <td>{{ format_Valor_variable(item.valor_bruto) }}</td>
                                        <td>{{ format_Valor_variable(item.valor_liquido) }}</td>
                                        <td>
                                            <b-button size="sm" variant="primary" @click="modal_editar(item)"><i class="bx bx-pencil"></i></b-button>
                                            <b-button size="sm" variant="danger" @click="eliminar(item)"><i class="bx bx-trash"></i></b-button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <!-- <div class="row">
                            <div class="col">
                                <div class="dataTables_paginate paging_simple_numbers float-right">
                                    <ul class="pagination pagination-rounded mb-0">
                                        <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage"></b-pagination>
                                    </ul>
                                </div>
                            </div>
                        </div> -->
                        <b-modal ref="modal-editar" :title="obtenerLabotante(pago_editar.laborante_id)" ok-title="Editar" cancel-title="Cancelar" @ok="editar()" no-close-on-backdrop>
                            <div class="row">
                                <div class="col-md-12 mb-3">
                                    <p class="m-0 p-0" v-if="pago_editar.tipo_laborante=='Apoyo' || pago_editar.tipo_laborante=='Relator' || pago_editar.tipo_laborante=='Digitalizador'"><b>Código Evento:</b> {{ obtenerEvento(pago_editar.evento_id).codigo }}</p>
                                    <p class="m-0 p-0" v-if="pago_editar.tipo_laborante=='Apoyo' || pago_editar.tipo_laborante=='Relator' || pago_editar.tipo_laborante=='Digitalizador'"><b>Evento:</b> {{ obtenerEvento(pago_editar.evento_id).nombre_difusion }}</p>
                                    <p class="m-0 p-0"><b>Tipo Laborante:</b> {{ pago_editar.tipo_laborante }}</p>
                                </div>
                                <div class="col-md-6" v-if="pago_editar.tipo_laborante=='Apoyo Oficina' || pago_editar.tipo_laborante=='Digitalizador'">
                                    <div class="form-group">
                                        <label for="pais"> Fecha:</label>
                                        <date-picker v-model="pago_editar.fecha" value-type="YYYY-MM-DD" format="DD-MM-YYYY" :first-day-of-week="2" lang="es" ></date-picker>
                                    </div>
                                </div>
                                <div class="col-md-6" v-if="pago_editar.tipo_laborante!='Digitalizador'">
                                    <label for="pais"> Hora inicio:</label>
                                    <date-picker v-model="pago_editar.hora_inicio" type="time" value-type="format" format="HH:mm" :first-day-of-week="2" lang="es" @input="valor_pago_actualizar"></date-picker>
                                </div>
                                <div class="col-md-6" v-if="pago_editar.tipo_laborante!='Digitalizador'">
                                    <label for="pais"> Hora fin:</label>
                                    <date-picker v-model="pago_editar.hora_fin" type="time" value-type="format" format="HH:mm" :first-day-of-week="2" lang="es" @input="valor_pago_actualizar"></date-picker>
                                </div>
                                <div class="col-md-6" v-if="pago_editar.tipo_laborante=='Digitalizador'">
                                    <label for="pais"> Cantidad de encuestas:</label>
                                    <input type="number" id="direccion" v-model="pago_editar.cantidad_encuestas" class="form-control border-primary" @blur="valor_pago_actualizar">
                                </div>
                                <div class="col-md-6">
                                    <label for="pais"> Valor Bruto:</label>
                                    <input type="number" id="direccion" v-model="pago_editar.valor_bruto" class="form-control border-primary">
                                </div>
                                <div class="col-md-6">
                                    <label for="pais"> Valor Líquido:</label>
                                    <input type="number" id="direccion" v-model="pago_editar.valor_liquido" class="form-control border-primary">
                                </div>
                            </div>
                        </b-modal>
                    </div>
                </div>
            </div>
        </div>
    </Layout>
</template>
